// extracted by mini-css-extract-plugin
export default {"accordionHover":"MainPage_accordionHover__6di2x","Main":"MainPage_Main__y9dui"};